import { track } from '@/helpers/tracking';
// Content tree from JobCreationService: domain and office listings sit 1-2 levels below the overview.
const MAX_LISTING_DEPTH = 2;
function segmentsOf(path) {
    return path.toLowerCase().split('/').filter(Boolean);
}
/**
 * Whether `pathname` is the job overview page or one of its filtered listings. Vacancy detail pages
 * are excluded; those push `job_click`.
 */
export function isJobListingPath(pathname, overviewPath) {
    const overview = segmentsOf(overviewPath);
    if (overview.length === 0)
        return false;
    const path = segmentsOf(pathname);
    const depth = path.length - overview.length;
    if (depth < 0 || depth > MAX_LISTING_DEPTH)
        return false;
    if (overview.some((segment, index) => segment !== path[index]))
        return false;
    // A lone numeric segment is a Greenhouse job id, redirected to the vacancy by JobRedirectMiddleware.
    return !(depth === 1 && /^\d+$/.test(path[overview.length]));
}
/**
 * Pushes `click_open_positions` for same-origin link clicks into the job listings.
 */
export function initOpenPositionsTracking() {
    const onClick = (event) => {
        if (!(event.target instanceof Element))
            return;
        const anchor = event.target.closest('a[href]');
        if (!(anchor instanceof HTMLAnchorElement))
            return;
        if (anchor.origin !== window.location.origin)
            return;
        if (anchor.hash && anchor.pathname === window.location.pathname)
            return;
        // Read lazily: _GoogleTagManager.cshtml may run after main.js on some layouts.
        const overviewUrl = window.__jobOverviewUrl;
        if (!overviewUrl)
            return;
        if (!isJobListingPath(anchor.pathname, new URL(overviewUrl, window.location.origin).pathname))
            return;
        track({ event: 'click_open_positions' });
    };
    document.addEventListener('click', onClick);
    return () => document.removeEventListener('click', onClick);
}
